<template>

    <div v-cloak class="container-fluid">
        <div v-if="apptOutage && preSelectedRequestTypeId !='New'" id="body-container" class="card card-default portal-form-background my-2 p-2">
            <div class="row">
                <div class="col text-portal-secondary-red">
                    <h5>
                        We&apos;re making some updates to our system, and your appointment information is not available at this time. We apologize for the inconvenience.
                        <br /><br />
                        You can still join a telemedicine visit. Click the link we sent you 2 hours before your appointment by email or text message.
                    </h5>
                </div>
            </div>
        </div>
        <!-- main page-->
        <div v-show="mode == 'Entry'">

            <div class="row">
                <div class="col">
                    <h1 class="text-portal-soft-black pt-2 h4" v-once>{{cmsContentBlocks['templateSelector.MainPage.Header']}}</h1>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <hr class="mt-0 mb-0 border-none taller-hr">
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <h2 class="text-portal-soft-black h5" v-once>{{cmsContentBlocks['appointmentRequestComponent.SubHeader']}}</h2>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <span class="text-portal-soft-red" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeaderImportant']}}</span>
                    <span class="text-portal-soft-black" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeader']}}</span>
                </div>
            </div>

            <div class="row mt-2 mt-lg-0">
                <div class="col-12 col-lg-6">

                    <div class="row d-none d-lg-block">
                        <div class="col">
                            <hr>
                        </div>
                    </div>

                    <div v-if="sendToThisMailbox" class="row text-portal-soft-black mb-2">
                        <div class="col" v-once>
                            To: {{sendToThisMailbox}}
                        </div>
                    </div>

                    <div v-else>
                        <div class="row text-portal-soft-black mb-2">
                            <div class="col">
                                {{cmsContentBlocks['appointmentRequestComponent.ToMailboxLabel']}}
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <select2-component key="drDropDown" title="Send message to this person" v-error-message="{ errorModel: 'errorModel.toMailboxId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="physicianDropDown" v-model="messageModel.toMailboxId" :placeholder="cmsContentBlocks['appointmentRequestComponent.ToMailboxPlaceHolder']">
                                </select2-component>
                                <span class="invalid-feedback is-invalid">{{ errorModel.toMailboxId | firstError }}</span>
                            </div>
                        </div>
                    </div>

                    <div v-if="showPhysicianDropDown">
                        <div class="row text-portal-soft-black mb-2">
                            <div class="col">
                                Physician
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <select2-component key="physDropDown" title="Send message to this person" v-error-message="{ errorModel: 'errorModel.toPhysicianId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="reassignPhysicianDropDown" v-model="messageModel.toPhysicianId" :placeholder="cmsContentBlocks['appointmentRequestComponent.ToMailboxPlaceHolder']">
                                </select2-component>
                                <!--<span class="invalid-feedback is-invalid">{{ errorModel.toPhysicianId | firstError }}</span>-->
                            </div>
                        </div>
                    </div>

                    <div>

                        <div class="row text-portal-soft-black mb-2">
                            <div class="col" v-once>
                                {{cmsContentBlocks['appointmentRequestComponent.RequestTypeLabel']}}
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col">
                                <select2-component key="requestType" title="Request Type" data-minimum-results-for-search="Infinity" v-error-message="{ errorModel: 'errorModel.requestType' }" class="form-control" :options="requestTypeReferenceData" v-model="messageModel.requestType" :placeholder="cmsContentBlocks['appointmentRequestComponent.RequestTypeLabel']">
                                </select2-component>
                                <span class="invalid-feedback is-invalid">{{ errorModel.requestType | firstError }}</span>
                            </div>
                        </div>

                        <div v-if="showPreferredAppointment">

                            <div class="row text-portal-soft-black mb-2">
                                <div class="col">
                                    <label for="preferredDate" tabindex=0 aria-label="Preferred date">{{cmsContentBlocks['appointmentRequestComponent.PreferredApptDateLabel']}}</label>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col">
                                    <div class="input-group">
                                        <date-picker-component ref="preferredDesktop"
                                                               id="preferredDate"
                                                               :typeable="true"
                                                               v-error-message="{ errorModel: 'errorModel.preferredAppointmentDate' }"
                                                               :disabled-dates="disabledDates"
                                                               class="form-control vdp-datepickerinput"
                                                               placeholder="MM / DD / YYYY"
                                                               format="MM/dd/yyyy"
                                                               v-model="messageModel.preferredAppointmentDate">
                                        </date-picker-component>

                                        <div class="input-group-append">
                                                <button @click="$refs.preferredDesktop.showCalendar()" class="input-group-text bg-white rounded-right">
                                                    <i class="far fa-calendar-alt text-primary"></i>
                                                </button>
                                        </div>
                                        <span class="invalid-feedback is-invalid">{{ errorModel.preferredAppointmentDate | firstError }}</span>
                                    </div>

                                </div>
                            </div>

                        </div>

                        <div v-if="showAppointmentsToTakeActionOn">
                            <div class="row text-portal-soft-black">
                                <div class="col">
                                    <!-- appointment to reschedule or cancel-->
                                    <span v-if="messageModel.requestType == 'Reschedule'">{{cmsContentBlocks.appointmentRequestComponentRequestTypeDisplayReschedule}}</span>
                                    <span v-if="messageModel.requestType == 'Cancel'">{{cmsContentBlocks.appointmentRequestComponentRequestTypeDisplayCancel}}</span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <hr>
                                </div>
                            </div>

                            <div class="appointment-tile-container row text-portal-soft-black">
                                <div class="col">

                                    <div v-if="!futureAppointmentsAfterToday">
                                        <span>Loading Appointments, Please Wait...</span>
                                    </div>
                                    <div v-else v-for="appointmentRecord in futureAppointmentsAfterToday">
                                        <appointment-record-component prefix-id="appt" :appointment-record="appointmentRecord" name="desktop-appointment-to-take-action-on" v-model="messageModel.appointmentIdToTakeActionOn">
                                        </appointment-record-component>
                                    </div>

                                </div>
                            </div>

                            <div v-if="errorModel.appointmentIdToTakeActionOn" class="row">
                                <div class="col">
                                    <span class="d-block invalid-feedback is-invalid">{{errorModel.appointmentIdToTakeActionOn | firstError}}</span>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                <div class="col-12 col-lg-6">
                    <div class="row">
                        <div class="col">
                            <!--<banner-component v-if="nonEnglish" :bannerText="cmsContentBlocks.messageMustBeInEnglish"></banner-component>-->
                            <message-body-component v-model="messageModel.messageBody"
                                                    :error-model="errorModel"
                                                    :non-english="nonEnglish"
                                                    :cms-content-blocks="cmsContentBlocks"></message-body-component>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- end of main page-->

    </div>

</template>

<script>

    import Vue from 'vue';
    import './appointment.request.scss';
    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker';
    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';
    import composeMessageBody from '../../Common/message.body.vue';
    import select2Component from '@SharedVueComponents/select2/select2.vue';
    import appointmentRecordComponent from './appointment.record.vue';
    import jlinq from '@SharedServices/linq.javascript.service';
    import EventBus from '../../../message.event.bus';
    import mskBanner from '@PortalVueComponents/Banner/msk.banner.vue'

    export default {
        name: 'appointmentRequestTemplate',
        props: {
            preSelectedRequestTypeId: { type: String },
            preSelectedAppointmentId: { type: Number },
            physicianDropDown: { type: Array },
            futureAppointmentsOnFile: { type: Array },
            errorModel: { type: Object },
            cmsContentBlocks: { type: Object },
            apptOutage: { type: Boolean },
            //if set this is for ITC, DTC, etc. The "To Mailbox Id" will not be shown
            sendToThisMailbox: { type: String },
            //list of Reassign Physicians
            reassignPhysicianDropDown: { type: Array },
            //show or hide Reassign Physicians drop down
            showPhysicianDropDown: { type: Boolean },
            nonEnglish: { type: Boolean }
        },
        components: {
            'select2-component': select2Component,
            'date-picker-component': Datepicker,
            'message-body-component': composeMessageBody,
            'appointment-record-component': appointmentRecordComponent,
            'banner-component': mskBanner
        },
        data: function () {
            return {

                mode: 'Entry', //SelectMailbox, SelectPreferredDate, SelectAppointmentToTakeActionOn

                //only allow dates in the future for the date picker
                disabledDates: {
                    to: new Date(Date.now() - new Date().getMilliseconds())
                },

                messageModel: {
                    requestType: this.preSelectedRequestTypeId, //'Reschedule, New, Cancel'
                    toMailboxId: null, //mailbox id
                    toPhysicianId: "", //physician id
                    preferredAppointmentDate: null,
                    appointmentIdToTakeActionOn: this.preSelectedAppointmentId,  //this is the appointment id
                    messageBody: '',
                }
            }
        },
        mounted: function () {

            //go send back the model right away
            this.$emit('setMessageObject', this.messageModel);

            //starts on the compose.message.index.vue --> tells us when the sub screen (specific template mobile screen "done" button is pressed)
            EventBus.$on('SubScreenDoneButtonPushed', () => {
                this.mode = 'Entry';
            });

            //make sure this stuff is loaded first as it's lazy loaded (appointments should be pre-loaded when you want to preselect an appointment)
            this.preSelectAnAppointmentOnAppointmentIdToTakeActionOn();
        },
        destroyed: function () {
            EventBus.$off('SubScreenDoneButtonPushed');
        },
        watch: {

            futureAppointmentsOnFile: function (newValue, oldValue) {
                this.preSelectAnAppointmentOnAppointmentIdToTakeActionOn();
            },

            preSelectedRequestTypeId: function (newValue, oldValue) {
                this.messageModel.requestType = newValue;
            },

            'messageModel.toMailboxId': function (newValue, oldValue) {
                //if we are in mobile land instead of having them scroll to the bottom just accept the value
                if (this.mode != 'Entry') {
                    this.mode = 'Entry';
                }
            },

            'messageModel.appointmentIdToTakeActionOn': function (newValue, oldValue) {
                //clear any errors
                Vue.delete(this.errorModel, 'appointmentIdToTakeActionOn');
            },

            messageModel: {
                handler: function (newValue) {
                    this.$emit('setMessageObject', newValue);
                },
                deep: true
            },

            mode: function (newValue, oldValue) {

                let isEntryScreen = newValue == 'Entry';

                this.$emit('showHideHeaderFooter', isEntryScreen, isEntryScreen); //showHeader, showFilter
            },

            requestTypeReferenceData: function (newValue, oldValue) {
                this.messageModel.requestType = null;

                Vue.nextTick(() => {
                    this.messageModel.requestType = this.preSelectedRequestTypeId;
                });
            }
        },
        computed: {

            requestTypeReferenceData: function () {

                let data = [{ id: 'New', text: this.cmsContentBlocks['appointmentRequestComponent.NewRequest'] }];

                if (this.futureAppointmentsAfterToday && this.futureAppointmentsAfterToday.length > 0) {
                    data.push({ id: 'Reschedule', text: this.cmsContentBlocks['appointmentRequestComponent.RescheduleRequest'] });
                    data.push({ id: 'Cancel', text: this.cmsContentBlocks['appointmentRequestComponent.CancelRequest'] });
                }

                return data;
            },

            selectedMailboxName: function () {
                if (!this.messageModel.toMailboxId) {
                    return null;
                }

                return this.physicianDropDown.SelectMany(x => x.children).First(x => x.id == this.messageModel.toMailboxId).text;
            },

            futureAppointmentsAfterToday: function () {
                if (!this.futureAppointmentsOnFile) {
                    //not loaded yet
                    return null;
                }

                //we can only reschedule, cancel anything but same day appointments. They must call the doctor to cancel / reschedule the day of the appt
                let startDateToQuery = moment().endOf('day');

                return this.futureAppointmentsOnFile.filter(x => moment(x.appointmentDate).isAfter(startDateToQuery, 'day'))
            },

            showPreferredAppointment: function () {
                return this.messageModel.requestType != 'Cancel';
            },

            showAppointmentsToTakeActionOn: function () {
                return this.messageModel.requestType == 'Reschedule' || this.messageModel.requestType == 'Cancel';
            },

            selectedAppointmentRecord: function () {
                if (!this.messageModel.appointmentIdToTakeActionOn) {
                    return null;
                }

                return this.futureAppointmentsOnFile.FirstOrDefault(x => x.id == this.messageModel.appointmentIdToTakeActionOn);
            },

            recentMailboxGroup: function () {
                //recent could be blank if they haven't sent any message
                if (!this.physicianDropDown || !this.physicianDropDown.Any(x => x.text == 'Recent')) {
                    return [];
                }

                return this.physicianDropDown.First(x => x.text == 'Recent').children;
            },

            allMailboxGroup: function () {
                if (!this.physicianDropDown) {
                    return [];
                }

                return this.physicianDropDown.First(x => x.text == 'All').children;
            }

        },
        methods: {

            preSelectAnAppointmentOnAppointmentIdToTakeActionOn: function () {
                if (this.preSelectedAppointmentId && this.futureAppointmentsOnFile) {
                    Vue.nextTick(() => {
                        $('.appointment-tile-container').scrollTop($('.appointment-tile-container').scrollTop() + $('#appointment-selector-' + this.preSelectedAppointmentId).position().top);
                    });
                }
            }

        }
    };
</script>

